
import dayjs from 'dayjs';
import apiClient from './ApiInterceptor';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const fetchClosures= async (branchId, fromDate, toDate) => {
     const params = {
        from: dayjs.utc(fromDate).format('YYYY-MM-DD HH:mm:ss'),
        to: dayjs.utc(toDate).format('YYYY-MM-DD HH:mm:ss'),
        branchId: branchId
    };

    const response = await apiClient.get('/closures', { params });
    return response.data;
};
